import axios from "axios";
import {
  EMPTY_QETAF,
  ERROR_QETAF_OTP,
  ERROR_QETAF_COMPLETE,
  ERROR_QETAF_REDEEM,
  ERROR_QETAF_REVERSE,
  ERROR_QETAF_UPDATE_REWARD,
  FETCH_QETAF_OTP,
  FETCH_QETAF_COMPLETE,
  FETCH_QETAF_REDEEM,
  FETCH_QETAF_REVERSE,
  FETCH_QETAF_UPDATE_REWARD,
  LOAD_QETAF_OTP,
  LOAD_QETAF_COMPLETE,
  LOAD_QETAF_REDEEM,
  LOAD_QETAF_REVERSE,
  LOAD_QETAF_UPDATE_REWARD,
} from "./Types";

const qetafConfig = (token) => ({
  headers: {
    "Content-Type": "application/json",
    "X-Authorization-Firebase": token,
  },
});

const getErrorPayload = (error) => {
  if (error && error.response && error.response.data) {
    return error.response.data;
  }
  return error && error.message ? error.message : "حدث خطأ ما، يرجى المحاولة لاحقاً";
};

export const requestQetafOtp = (msisdn, internalReference) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({
      type: LOAD_QETAF_OTP,
      payload: true,
    });

    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        return axios.post(
          "/qetaf/redemption/otp",
          { msisdn, internalReference },
          qetafConfig(token)
        );
      })
      .then((res) => {
        dispatch({
          type: FETCH_QETAF_OTP,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR_QETAF_OTP,
          payload: getErrorPayload(error),
        });
      });
  };
};

export const redeemQetafPoints = (msisdn, pin, amount, internalReference, remainingAmountSar) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({
      type: LOAD_QETAF_REDEEM,
      payload: true,
    });

    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        return axios.post(
          "/qetaf/redemption/redeem",
          { msisdn, pin, amount, internalReference, remainingAmountSar },
          qetafConfig(token)
        );
      })
      .then((res) => {
        dispatch({
          type: FETCH_QETAF_REDEEM,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR_QETAF_REDEEM,
          payload: getErrorPayload(error),
        });
      });
  };
};

export const completeQetafSubscription = (
  internalReference,
  paymentPackageType,
  remainingAmountSar,
  remainingPaymentMethod
) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({
      type: LOAD_QETAF_COMPLETE,
      payload: true,
    });

    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        return axios.post(
          "/qetaf/redemption/complete-subscription",
          {
            internalReference,
            paymentPackageType,
            remainingAmountSar,
            remainingPaymentMethod,
          },
          qetafConfig(token)
        );
      })
      .then((res) => {
        dispatch({
          type: FETCH_QETAF_COMPLETE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR_QETAF_COMPLETE,
          payload: getErrorPayload(error),
        });
      });
  };
};

export const requestQetafReverseByMsisdn = (msisdn, internalReference) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({
      type: LOAD_QETAF_REVERSE,
      payload: true,
    });

    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        return axios.post(
          "/qetaf/redemption/reverse-request-by-msisdn",
          { msisdn, internalReference },
          qetafConfig(token)
        );
      })
      .then((res) => {
        dispatch({
          type: FETCH_QETAF_REVERSE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR_QETAF_REVERSE,
          payload: getErrorPayload(error),
        });
      });
  };
};

export const updateQetafRewardPoints = (msisdn, internalReference, reductionAmount) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({
      type: LOAD_QETAF_UPDATE_REWARD,
      payload: true,
    });

    firebase
      .auth()
      .currentUser.getIdToken()
      .then((token) => {
        return axios.post(
          "/qetaf/redemption/update-reward-points",
          { msisdn, internalReference, reductionAmount },
          qetafConfig(token)
        );
      })
      .then((res) => {
        dispatch({
          type: FETCH_QETAF_UPDATE_REWARD,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ERROR_QETAF_UPDATE_REWARD,
          payload: getErrorPayload(error),
        });
      });
  };
};

export const emptyQetaf = () => ({
  type: EMPTY_QETAF,
  payload: "",
});
